import type { SvgProps } from "replo-utils/react/components";

import * as React from "react";

import { Svg } from "replo-utils/react/components";

const ReploBuilder = (props: SvgProps) => (
  <Svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="32" height="32" rx="8" fill="black" />
    <rect
      x="0.25"
      y="0.25"
      width="31.5"
      height="31.5"
      rx="7.75"
      stroke="#F5FAD9"
      strokeOpacity="0.2"
      strokeWidth="0.5"
    />
    <path
      d="M9.94813 22.6666H13.182C13.5792 22.6666 13.9007 22.3452 13.9007 21.948V19.4514C13.9007 19.2813 14.0329 19.1485 14.2035 19.1485C14.3357 19.1485 14.4685 19.2429 14.5063 19.3757C15.3007 21.8723 18.0431 22.6474 20.0854 22.6474H22.0521C22.4493 22.6474 22.7707 22.326 22.7707 21.9288V18.6757C22.7707 18.2785 22.4493 17.957 22.0521 17.957H19.2154C18.8939 17.957 18.7425 17.5791 18.9696 17.3519L22.1092 14.2124C22.3928 13.9288 22.5442 13.5502 22.5442 13.1531V10.052C22.5442 9.65478 22.2227 9.33331 21.8256 9.33331H18.7052C18.3273 9.33331 17.9487 9.48473 17.6651 9.76834L14.5256 12.9079C14.2984 13.135 13.9013 12.9644 13.9013 12.6429V10.052C13.9013 9.65478 13.5798 9.33331 13.1826 9.33331H10.1182C9.721 9.33331 9.39954 9.65478 9.39954 10.052V13.0966C9.39954 13.4937 9.721 13.8152 10.1182 13.8152H12.7278C13.0492 13.8152 13.2007 14.2124 12.9735 14.4395L11.3091 15.9904C10.0996 17.1254 9.22949 18.7135 9.22949 20.3779V21.9474C9.22949 22.3446 9.55096 22.666 9.94813 22.666V22.6666ZM16.473 18.0898C15.5843 18.0712 14.79 18.1463 14.2227 17.7491C13.6741 17.2762 13.7691 16.4633 13.7312 15.7825C13.7498 15.1017 13.6934 14.213 14.147 13.7587C14.6007 13.3045 15.49 13.3237 16.1515 13.3429C16.8515 13.3808 17.6645 13.2864 18.1374 13.8344C18.5154 14.4017 18.4402 15.196 18.4589 16.0847C18.4402 16.6333 18.4589 17.257 18.0809 17.6734L18.0431 17.7113C17.6459 18.0706 17.003 18.052 16.4736 18.0892L16.473 18.0898Z"
      fill="#F5FAD9"
    />
  </Svg>
);

export default ReploBuilder;
